import { css } from 'aphrodite';
import * as React from 'react';
import { Button } from '../../../web/components-v2/Button';
import { styles } from './styles';

interface IProps {
	children: React.ReactNode;
}

interface IState {
	hasError: boolean;
	error: Error | null;
}

/**
 * Error boundary for the events landing page. Shows a generic error message
 * rather than the "no events" empty state so a runtime React failure isn't
 * misread by visitors as the account having zero upcoming events.
 */
export class EventsErrorBoundary extends React.Component<IProps, IState> {
	public readonly state: IState = {
		hasError: false,
		error: null,
	};

	public static getDerivedStateFromError(error: Error): IState {
		return {
			hasError: true,
			error,
		};
	}

	public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
		console.error('EventsLandingPage Error:', error, errorInfo);
	}

	private handleRefresh = () => {
		window.location.reload();
	};

	public render() {
		if (this.state.hasError) {
			return (
				<div className={css(styles.errorContainer)}>
					<div className={css(styles.errorContent)}>
						<h1 className={css(styles.errorTitle)}>Something went wrong</h1>
						<p className={css(styles.errorMessage)}>
							We&apos;re having trouble displaying this page. Please refresh to try again.
						</p>
					</div>
					<div className={css(styles.refreshPrompt)}>
						<Button onClick={this.handleRefresh} variant='primary' size='lg'>
							Refresh Page
						</Button>
					</div>
				</div>
			);
		}

		return this.props.children;
	}
}
